import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    fallbackBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.color.background.light,
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
    },
});
const FallbackBackground = (props) => {
    const { classes, children } = props;
    return React.createElement("div", { className: classes.fallbackBackgroundContainer }, children);
};
export default compose(withBaseProps({ styles }))(FallbackBackground);
//# sourceMappingURL=FallbackBackground.js.map